export function trim(str) {
    return String.prototype.trim.call(str);
}

export function isType(arg, type) {
    return Object.prototype.toString.call(arg) === "[object " + type + "]";
}

export function isWeixin() {
    return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}

export function parseQuery() {
    const res = {};

    const query = (location.href.split("?")[1] || "")
        .trim()
        .replace(/^(\?|#|&)/, "");

    if (!query) {
        return res;
    }

    query.split("&").forEach((param) => {
        const parts = param.replace(/\+/g, " ").split("=");
        const key = decodeURIComponent(parts.shift());
        const val =
            parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

        if (res[key] === undefined) {
            res[key] = val;
        } else if (Array.isArray(res[key])) {
            res[key].push(val);
        } else {
            res[key] = [res[key], val];
        }
    });

    return res;
}

const VUE_APP_API_URL =
    (process.env.VUE_APP_API_URL || "").trim() || "admin.ydtz62.com";
const VUE_APP_WS_URL =
    (process.env.VUE_APP_WS_URL || "").trim() || "wss://admin.ydtz62.com/wss";

/** 与 vue.config.js 中 devServer.proxy 前缀一致 */
export const H5_DEV_API_PREFIX =
    process.env.NODE_ENV === "development" ? "/h5-dev-api" : "";

/**
 * 生产环境 API 根地址（末尾带 /）。
 * - 若配置为完整 URL（含 https:// 或 http://）则原样使用，便于强制指定协议。
 * - 若仅为域名：HTTPS 页面用 https，避免 Mixed Content；HTTP 页面用 http。
 */
export function resolveProductionApiBase(hostOrUrl) {
    let raw = String(hostOrUrl || "").trim();
    if (!raw) {
        raw = "admin.ydtz62.com";
    }
    if (/^https?:\/\//i.test(raw)) {
        let u = raw.replace(/\/+$/, "");
        if (
            typeof window !== "undefined" &&
            window.location &&
            window.location.protocol === "https:" &&
            /^http:\/\//i.test(u)
        ) {
            u = u.replace(/^http:\/\//i, "https://");
        }
        return u + "/";
    }
    const host = raw.replace(/^\/+/, "").replace(/\/+$/, "");
    const proto =
        typeof window !== "undefined" &&
        window.location &&
        window.location.protocol === "https:"
            ? "https:"
            : "http:";
    return `${proto}//${host}/`;
}

/**
 * 拼接接口绝对 URL（验证码图、上传地址等）。开发环境走本地代理前缀。
 * @param {string} pathWithQuery 须以 / 开头，可含查询串，如 "/captcha?k=1"
 */
export function apiUrl(pathWithQuery) {
    const s = pathWithQuery.startsWith("/")
        ? pathWithQuery
        : "/" + pathWithQuery;
    if (process.env.NODE_ENV === "development") {
        return H5_DEV_API_PREFIX + s;
    }
    const base = resolveProductionApiBase(VUE_APP_API_URL);
    return base.replace(/\/+$/, "") + s;
}

/**
 * 主站 HTTPS 且客服链接为 http 时，浏览器禁止 iframe 嵌入，只能整页跳转打开。
 */
export function isKfHttpOnHttpsPage(kfUrl) {
    const kf = String(kfUrl || "").trim();
    if (!kf) return false;
    if (typeof window === "undefined" || !window.location) return false;
    return window.location.protocol === "https:" && /^http:\/\//i.test(kf);
}

export { VUE_APP_API_URL, VUE_APP_WS_URL };
